import moment from 'moment';
import { UNITS, TIMESCALE, FUEL_TYPE, USAGE_TYPE, USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW, USAGE_DASHBOARD_HOUR_ITEMS_TO_SHOW, TEMPERATURE, ONGOING, NA, SHC_BC } from '../constants/common';
import { createDummyDataHomeItemizationXAxis } from '../helpers/noDataHelper';
import  currentViewGraphImg  from '../assets/img/currentView.gif';

export const checkIfArrayOfZeroes = (arr) => {
    if (arr && arr.length > 0) {
        return arr.every(item => item === 0 || item === null)
    }
    return true;
}

export const fetchBillingCycleDateBoundaries = (params) => {
    let start = 0;
    let end = Math.floor(new Date().getTime()/1000);
    let dateFormat = 'DATE_TIME';
    if (params.mode === TIMESCALE.MONTH) {
        start = params.dataMonthStart ? params.dataMonthStart : start;
        end = params.dataMonthEnd ? params.dataMonthEnd : end;
    }
    if (params.mode === TIMESCALE.DAY) {
        start = params.dataDayStart ? params.dataDayStart : start;
        end = params.dataDayEnd ? params.dataDayEnd : end;
    }
    if (params.mode === TIMESCALE.HOUR) {
        start = params.dataHourStart ? params.dataHourStart : start;
        end = params.dataHourEnd ? params.dataHourEnd : end;
    }
    if (params.mode === SHC_BC) {
        dateFormat = 'MONTH_IN_WORDS_SPACE_DAY_COMMA_YEAR';
    }
    return {
        start: start,
        end: end,
        dateFormat: dateFormat
    };
}

export const getDataNotAvailableText = (params, translations) => {
    let dataNotAvailableText = '';
    if (params.mode === TIMESCALE.YEAR) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.YEAR"];
    }else if (params.mode === TIMESCALE.MONTH) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.MONTH"];
    }else if (params.mode === TIMESCALE.HOUR || params.mode === TIMESCALE.DAY) {
        dataNotAvailableText = "No data for this Cycle";
    }else if (params.mode === SHC_BC) {
        dataNotAvailableText = translations["USAGE.DATA_NOT_AVAILABLE.SHC"];
    }
    return dataNotAvailableText;
}

export const createVariableFromApplianceName = (key, type) => {
    return ("data" + key + type.charAt(0).toUpperCase() + type.substring(1));
}

export const setUsageChartDataForYear = (graphApiData, appliancesList) => {
    let data = {
        dataNACost: [], dataNAEnergy: [], dataTimeStampsYear: [],
        dataOngoingCost: [], dataOngoingEnergy: []
    };
    let keys = Object.keys(appliancesList);
    keys.forEach(key => {
        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)] = [];
        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)] = [];
        return key;
    });

    graphApiData.map( (item, index) => {
        //Push billingcycle start and end to create array of billingCycles
        data.dataTimeStampsYear.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });

        if (item.itemizationDetailsList) {
            let itemizationDetailsList = item.itemizationDetailsList;
            //Create array of itemizations from api to feed highcharts
            itemizationDetailsList.map(item => {
                keys.forEach(key => {
                    if (item.id == key) {
                        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(item.cost ? item.cost : 0);
                        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(item.usage ? item.usage : 0);
                        return key;
                    }
                });
                return item;
            });

            //If itemization for a specific category is not present for that billing cycle, pad with 0
            keys.forEach(key => {
                if (data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].length !== index + 1) {
                    data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                    data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                }
                return key;
            });

            data.dataNACost.push(0);
            data.dataNAEnergy.push(0);
        }else {
            //If itemization is not present, push into itemization unavailable or ongoing cycle array and pad other arrays with 0 value
            if (item.isOngoingInterval) {
                //If it is the ongoing billing cycle, push into that array. Create an array of that lenth and then push the next value
                data.dataOngoingCost = new Array(index).fill(0);
                data.dataOngoingEnergy = new Array(index).fill(0);
                data.dataOngoingCost.push(item.cost ? item.cost : 0);
                data.dataOngoingEnergy.push(item.consumption ? item.consumption : 0);
                data.dataNACost.push(0);
                data.dataNAEnergy.push(0);
            }else {
                //If ongoing is false, push into itemization not available array
                //If cost/consumption is null, then push 0
                data.dataNACost.push(item.cost ? item.cost : 0);
                data.dataNAEnergy.push(item.consumption ? item.consumption : 0);
            }
            keys.forEach(key => {
                data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                return key;
            });
        }
    });
    return data;
}

export function mappingHourKeys(load) {
    let mapping = {
        '1': "AC1",
        '2': "AC2",
        '3': "Refrigerator",
        '4': "Furnance fan",
        '8': "Water heater",
        '9': "computer"
    }
    return mapping[load];
  }

export function getChartXYplotPointsForHour(chart, mode, currentViewData) {
    let currentDate = moment.unix(currentViewData).format('YYYY-MM-DD');
    let m = moment();
    let today = moment().format('YYYY-MM-DD');
    if(currentDate === today) {    // check date is today's date or not
        let minHourStr = m.format("hh:mm");
        if(mode === TIMESCALE.DAY) {
            let mins = m.format('mm');
            mins = mins - (mins%10);
            minHourStr = m.format('hh:' + mins + ' A');
        }
        let xAxisArr = chart.userOptions.xAxis[0].categories;
        var arrIndex = xAxisArr.lastIndexOf(minHourStr);
        if(arrIndex != -1 ) {   /// current time is present in xAxis of chart
          let maxVal = null;
          var point = null;
          // check maximum value of series data and take that point for plotting x and y
          for(let i = 0; i <= (chart.series.length - 1 ); i++) {
            if(chart.series[i].data.length) {
              if (maxVal && maxVal < chart.series[i].data[arrIndex].y) {
                maxVal = chart.series[i].data[arrIndex].y;
                point = chart.series[i].data[arrIndex];
              } else if (maxVal == null) {
                maxVal = chart.series[i].data[arrIndex].y;
                point = chart.series[i].data[arrIndex];
              }
            }
          }
          var xPoint = point.plotX + chart.plotLeft - 14;  // set image x
          var yPoint = point.plotY + chart.plotTop - 25;   // set image y
          chart.renderer.image(currentViewGraphImg, xPoint, yPoint , 30, 30).add();
        }
    }
}

export const setUsageChartDataForHour = (graphApiData, appliancesList) => {
    let data = {
        dataNACost: [], dataNAEnergy: [], dataTimeStampsHour: [],
        dataOngoingCost: [], dataOngoingEnergy: []
    };
    let keys = Object.keys(appliancesList);
    keys.forEach(key => {
        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)] = [];
        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)] = [];
        return key;
    });

    graphApiData.map( (item, index) => {
        //Push billingcycle start and end to create array of billingCycles
        data.dataTimeStampsHour.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });

        if (item.itemizationDetailsList) {
            let itemizationDetailsList = item.itemizationDetailsList;
            //Create array of itemizations from api to feed highcharts
            itemizationDetailsList.map(item => {
                keys.forEach(key => {
                    if (item.id == key) {
                        data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(item.cost ? item.cost : 0);
                        data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(item.usage ? item.usage : 0);
                        return key;
                    }
                });
                return item;
            });

            // If itemization for a specific category is not present for that billing cycle, pad with 0
            keys.forEach(key => {
                if (data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].length !== index + 1) {
                    data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                    data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                }
                return key;
            });

            data.dataNACost.push(0);
            data.dataNAEnergy.push(0);
        }else {
            //If itemization is not present, push into itemization unavailable or ongoing cycle array and pad other arrays with 0 value
            if (item.isOngoingInterval) {
                //If it is the ongoing billing cycle, push into that array. Create an array of that lenth and then push the next value
                data.dataOngoingCost = new Array(index).fill(0);
                data.dataOngoingEnergy = new Array(index).fill(0);
                data.dataOngoingCost.push(item.cost ? item.cost : 0);
                data.dataOngoingEnergy.push(item.consumption ? item.consumption : 0);
                data.dataNACost.push(0);
                data.dataNAEnergy.push(0);
            }else {
                //If ongoing is false, push into itemization not available array
                //If cost/consumption is null, then push 0
                data.dataNACost.push(item.cost ? item.cost : 0);
                data.dataNAEnergy.push(item.consumption ? item.consumption : 0);
            }
            keys.forEach(key => {
                data[createVariableFromApplianceName(key, USAGE_TYPE.COST)].push(0);
                data[createVariableFromApplianceName(key, USAGE_TYPE.ENERGY)].push(0);
                return key;
            });
        }
    });
    return data;
}

export const setUsageChartDataForMonth = (graphApiData) => {
    let dataTimeStampsMonth = [], dataMonthCost = [], dataMonthEnergy = [], isWeekend = [];

    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        dataTimeStampsMonth.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });
        dataMonthCost.push(item.cost);
        dataMonthEnergy.push(item.consumption);
        isWeekend.push(item.isWeekend);
    });

    return {
        dataTimeStampsMonth,
        dataMonthCost,
        dataMonthEnergy,
        isWeekend
    };
}


export const setSHChartDataForBC = (graphApiData, mode, selectedAppliance) => {
    let bcTimeStampsData = [];
    let youSeriesData = [];
    let efficientSeriesData = [];
    let averageSeriesData = [];

    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        bcTimeStampsData.push({
            start: item.intervalStart,
            end: item.intervalEnd,
            isMissingDataInterval: item.isMissingDataInterval
        });

        let applianceInfo = item.applianceInfo[selectedAppliance];
        let youVal = null;
        let averageVal = null;
        let efficientVal = null;
        let isCost = mode == USAGE_TYPE.COST;

        //If data is null, convert them to zero
        if (!item.isMissingDataInterval && applianceInfo) {
            youVal = isCost ? applianceInfo.userCost : applianceInfo.userCons;
            averageVal = isCost ? applianceInfo.averageSHCCost : applianceInfo.averageSHCCons;
            efficientVal = isCost ? applianceInfo.efficientSHCCost : applianceInfo.efficientSHCCons;
        }
        youSeriesData.push(youVal);
        averageSeriesData.push(averageVal);
        efficientSeriesData.push(efficientVal);
    });

    return {
        bcTimeStampsData,
        youSeriesData,
        averageSeriesData,
        efficientSeriesData
    };
}

export const setUsageChartDataForDay = (graphApiData) => {
    let dataTimeStampsDay = [];

    let dataDayCost = [], dataDayEnergy = [];

    graphApiData.map( item => {
        //Push billingcycle start and end to create array of billingCycles
        dataTimeStampsDay.push({
            start: item.intervalStart,
            end: item.intervalEnd
        });
        dataDayCost.push(item.cost);
        dataDayEnergy.push(item.consumption);
    });

    return {
        dataTimeStampsDay,
        dataDayCost,
        dataDayEnergy
    };
}

export const setTooltip = (currentObj, self) => {
    let total = 0, checkIfNA = false, checkIfOngoing = false;

    let electricCostUnit = self.props.configs.data.electric_cost_unit;
    let electricEnergyUnit = self.props.configs.data.electric_energy_unit;
    let gasCostUnit = self.props.configs.data.gas_cost_unit;
    let gasEnergyUnit = self.props.configs.data.gas_energy_unit;

    //Fetch index of point to calculate the index of billing cycle duration from array of dataBillingCycleDuration
    let index = currentObj.points[0].point.index;
    if (self.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
        //If length is greater than 13, then show calculated index or else take default index by default
        index = self.props.insightsBillUsageData.dateStrings.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? self.props.insightsBillUsageData.dateStrings.length - (USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - index + self.props.insightsBillUsageData.datasYearIndexOffset) : index;
    }

    //Show tooltip based on mode
    let dateString = self.props.insightsBillUsageData.dateStrings[index];

    let tooltipData;
    if (self.props.insightsBillUsageData.mode !== TIMESCALE.HOUR) {
        tooltipData = moment(dateString.startDate).format(self.props.configs.data[`DATE_FORMATS.${self.props.insightsBillUsageData.mode.toUpperCase()}.TOOLTIP`]);
    } if ((self.props.insightsBillUsageData.mode === TIMESCALE.HOUR || self.props.insightsBillUsageData.mode === TIMESCALE.DAY) && dateString && dateString.startDate ) {
        tooltipData = moment(dateString.startDate).format('HH:mm:ss A');  // format for Hour
    }

    if (self.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
        tooltipData += (" - " + moment(dateString.endDate).format(self.props.configs.data["DATE_FORMATS.YEAR.TOOLTIP"]));
    }

    //Calculate total excluding temperature values
    currentObj.points.map(item => item.series.name !== TEMPERATURE.NAME ? total += item.y : total);
    total = formatCostOrElectricValues(self.props.insightsBillUsageData.switchCostEnergy, self.props.insightsBillUsageData.switchGasElectric, {
        electricCostUnit: UNITS[electricCostUnit],
        gasCostUnit: UNITS[gasCostUnit],
        electricEnergyUnit: self.props.insightsBillUsageData.mode === TIMESCALE.HOUR ? "W" : UNITS[electricEnergyUnit],
        gasEnergyUnit: UNITS[gasEnergyUnit]
    }, total);

    let returnObj = currentObj.points.reduce(function(s, point) {
        if (self.props.insightsBillUsageData.mode !== TIMESCALE.YEAR) {
            if (point.series.name === TEMPERATURE.NAME && self.props.insightsBillUsageData.showWeather) {
                return s +
                    "<span class='insights-highcharts-tooltip-item-container'> " +
                        "<span class='insights-highcharts-tooltip-item-text insights-highcharts-tooltip-item-text-center'><b>" + point.series.name + ": " + point.y + ' ' + self.props.configs.data["weather_unit"] + "</b></span>" +
                    "</span>";
            }else {
                return s;
            }
        }else if (point.series.name === NA.NAME) {
            if (point.y > 0) {
                checkIfNA = true;
            }
            return s;
        }else if (point.series.name === ONGOING.NAME && point.y > 0 ) {
            checkIfOngoing = true;
            return s;
        }else if (point.series.name === TEMPERATURE.NAME && self.props.insightsBillUsageData.showWeather) {
            return s +
                "<span class='insights-highcharts-tooltip-item-container'> " +
                    "<span style='border-color: " + point.color + ";' class='insights-highcharts-tooltip-color insights-highcharts-tooltip-temperature'></span>" +
                    "<span style='background-color: " + point.color + "'; class='insights-highcharts-tooltip-temperature-strikethrough'></span>" +
                    "<span class='insights-highcharts-tooltip-item-text'><b>" + point.y + ' ' + self.props.configs.data["weather_unit"] + "</b>" + point.series.name + "</span>" +
                "</span>";
        }else if (!checkIfNA && !checkIfOngoing && point.y !== 0) {
            return s +
                "<span class='insights-highcharts-tooltip-item-container'> " +
                    "<span style='background-color: " + point.color + "' class='insights-highcharts-tooltip-color'></span>" +
                    "<span class='insights-highcharts-tooltip-item-text'><b>" + (self.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? (self.props.insightsBillUsageData.switchGasElectric === FUEL_TYPE.ELECTRIC ? UNITS[electricCostUnit] : UNITS[gasCostUnit]) : "") + point.y + (self.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.ENERGY ? (self.props.insightsBillUsageData.switchGasElectric === FUEL_TYPE.ELECTRIC ? UNITS[electricEnergyUnit] : UNITS[gasEnergyUnit]) : "") + "</b>" + point.series.name + "</span>" +
                "</span>";
        }else {
            return s;
        }
    }, '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
        '<span class="insights-highcharts-tooltip-total">' + self.props.translations.data["USAGE.TOTAL"] + ': ' + total + '</span></b>')

    if (checkIfNA) {
        return '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
            '<span class="insights-highcharts-tooltip-total">' + self.props.translations.data["USAGE.TOTAL"] + ': ' + total + '</span>' +
            '<b class="insights-highcharts-tooltip-unavailable">' + self.props.translations.data["USAGE.DISCLAIMER.ITEMIZATION_UNAVAILABLE"] + '</b>';
    }else if (checkIfOngoing) {
        return '<span class="insights-highcharts-tooltip-title">' + tooltipData + '</span>' +
            '<span class="insights-highcharts-tooltip-total">Current Usage: ' + total + '</span>' +
            '<b class="insights-highcharts-tooltip-unavailable">' + self.props.translations.data["USAGE.DISCLAIMER.ONGOING_BILLING_CYCLE"] + '</b>';
    }else {
        return returnObj;
    }
}

export const prepareUsageHistoryChartData = (chartApiData, displayValue) => {
    let xData = [], yData =[];
    let chartData = chartApiData;
    if (chartApiData.length === 0) {
        xData = createDummyDataHomeItemizationXAxis();
        for (let i = 0; i < 13; i++ ) {
            yData.push(Math.round(Math.random() * 400));
        }
    }else {
        if(chartApiData.length > 12){
            chartData = chartData.slice(chartApiData.length -12);
        }
        chartData.map ( item => {
            xData.push(item.intervalEndDate);
            let val = (displayValue === USAGE_TYPE.COST) ? item.cost : item.consumption;
            yData.push(val || 0);
        })
    }
    return {
        xAxisData : xData,
        yAxisData : yData
    }
}

export const checkIfDataEmpty = (array) => {
    for (let i = 0; i < array.length; i++) {
        if (!checkIfArrayOfZeroes(array[i].data)) {
            return false;
        }
    }
    return true;
}

export const formatCostOrElectricValues = (costOrEnergy, gasOrElectric, units, value) => {
    return ((costOrEnergy === USAGE_TYPE.COST ? (gasOrElectric === FUEL_TYPE.ELECTRIC ? units.electricCostUnit : units.gasCostUnit) : "") + value + (costOrEnergy === USAGE_TYPE.ENERGY ? (gasOrElectric === FUEL_TYPE.ELECTRIC ? units.electricEnergyUnit : units.gasEnergyUnit) : ""));
}
